<div class="modal-header border-bottom-0 py-0 d-flex align-items-center">
  <h5 class="modal-title font-18 d-flex align-items-center">Customize Activation Curve <p
      class="font-18 align-items-center" style="margin-top:14px;" *ngIf="geoLevelName"> - {{geoLevelName}}</p>
  </h5>
</div>
<div class="modal-body pt-0">
  <div class="loader loading-circle" *ngIf="savingInProgress || tabDataLoading">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link tab-basic cursor-pointer" (click)="openTabSwitchPopup('global')"
        [ngClass]="{'tab-active': activeTab === 'global', 'tab-inactive': activeTab !== 'global', 'disableTab': popupOpen }">
        Global Level
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link tab-basic cursor-pointer" (click)="openTabSwitchPopup('country')"
        [ngClass]="{'tab-active': activeTab === 'country', 'tab-inactive': activeTab !== 'country', 'disableTab': !enableCountryTab() || popupOpen }">
        Country Level
      </a>
    </li>
  </ul>

  <div class="result-container px-3 pt-3 pb-2 w-100">
    <div class="d-flex justify-content-between h-100">

      <!-- col-1 -->
      <div class="d-flex col-6 flex-column">

        <!-- ── Geography Activation block ── -->
        <div class="ps-0 pe-3 flex-fill card-block" style="max-height: none;">
          <div class="fw-bold font-16 mb-2">Geography Activation</div>
          <div class="d-flex justify-content-between mb-1 w-100 mt-2" *ngIf="siteSharingCohortError?.length > 0">
            <app-alerts [messageType]="'error'" [message]="siteSharingCohortError"
              (alertClosed)="siteSharingCohortError=''" [style.width.%]="100" [showCloseButton]="true">
            </app-alerts>
          </div>
          <div class="d-flex justify-content-between mb-1 w-100 mt-2" *ngIf="shareNumberError.length > 0">
            <app-alerts [messageType]="'error'" [message]="shareNumberError" (alertClosed)="shareNumberError=''"
              [style.width.%]="100" [showCloseButton]="true"></app-alerts>
            <!-- Geography Activation table ke baad, chart section se pehle -->


          </div>

          <!-- ── Geography Table with sticky header + scroll ── -->
          <div style="max-height: 300px; overflow-y: auto; overflow-x: hidden; border: 1px solid #cfdde6;">
            <table class="w-100" style="border-collapse: collapse; table-layout: fixed;">
              <!-- Sticky Header -->
              <thead style="position: sticky; top: 0; z-index: 2; background-color: #e5eaef;">
                <tr>
                  <th class="fw-bold px-2 py-2" style="font-size: 13px; color: #454250; width: 18%;">Geography</th>
                  <th class="fw-bold px-2 py-2" style="font-size: 13px; color: #454250; width: 20%;">Activation Curve
                  </th>

                  <!-- Country tab extra headers — sirf cohort study mein -->
                  <th *ngIf="activeTab === 'country' && isCohortStudy()" class="fw-bold px-2 py-2"
                    style="font-size: 13px; color: #454250; width: 20%;">
                    Share Site Number
                    <img placement="bottom" tooltipClass="tooltip-class"
                      ngbTooltip="Number of sites shared for this country" class="cursor-pointer ms-1"
                      src="assets/images/shared/info-icon.svg" height="12" width="12" alt="info">
                  </th>
                  <th *ngIf="activeTab === 'country' && isCohortStudy()" class="fw-bold px-2 py-2"
                    style="font-size: 13px; color: #454250; width: 32%;">
                    Sites Shared Among Cohort
                    <img placement="bottom" tooltipClass="tooltip-class"
                      ngbTooltip="Cohorts among which sites are shared" class="cursor-pointer ms-1"
                      src="assets/images/shared/info-icon.svg" height="12" width="12" alt="info">
                  </th>

                  <th class="fw-bold px-2 py-2"
                    style="font-size: 13px; color: #454250; width: 10%; text-align: center;">View</th>
                </tr>
              </thead>

              <!-- Scrollable Body -->
              <tbody *ngIf="!tabDataLoading">
                <tr *ngFor="let row of geographyGridData; index as i" style="border-bottom: 1px solid #cfdde6;">

                  <!-- Geography Name -->
                  <td class="px-2 py-2" style="font-size: 13px; color: #454250;">
                    <span class="txt-ellps">{{row.geographyName}}</span>
                  </td>

                  <!-- Activation Curve -->
                  <td class="px-2 py-2" style="font-size: 13px; color: #454250;">
                    <span *ngIf="row.siteActivationMethod && globalData.siteActivationMethod">Historical</span>
                    <span *ngIf="row.siteActivationMethod && !globalData.siteActivationMethod">Global Custom</span>
                    <span *ngIf="!row.siteActivationMethod">Customized</span>
                  </td>

                  <!-- Share Site Number — disable sirf isRowDisabled pe -->
                  <td *ngIf="activeTab === 'country' && isCohortStudy()" class="px-2 py-2"
                    [style.opacity]="row.isRowDisabled ? '0.5' : '1'"
                    [style.pointer-events]="row.isRowDisabled ? 'none' : 'auto'">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="row.shareSiteNumber"
                      (ngModelChange)="onShareSiteNumberChange(row)" placeholder="Enter number"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" [disabled]="popupOpen"
                      style="width: 100%;">
                  </td>

                  <!-- Sites Shared Among Cohort — disable sirf isRowDisabled pe -->
                  <td *ngIf="activeTab === 'country' && isCohortStudy()" class="px-2 py-2"
                    [style.opacity]="row.isRowDisabled ? '0.5' : '1'"
                    [style.pointer-events]="row.isRowDisabled ? 'none' : 'auto'">
                    <app-radius-dropdown [items]="row.feasibleCohorts?.length ? row.feasibleCohorts : availableCohorts"
                      [selectedItem]="row.sitesSharedAmongCohort || []" [dropdownConfig]="dropdownConfigurationsMulti"
                      [isDisabled]="popupOpen" (itemselected)="onCohortSelectionChange($event, row)">
                    </app-radius-dropdown>
                  </td>

                  <!-- View icon — hamesha enabled -->
                  <td class="py-2 text-center">
                    <span class="cursor-pointer" (click)="changeGridData(activeTab, i); closeCountryDropdown(i)"
                      [ngClass]="{'disabled': popupOpen}">
                      <img src="assets/images/view.svg" height="24px" width="24px" alt="">
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- ── END Geography Table ── -->


          <!-- ── SITE SHARING AMONG COHORTS — Global tab + sirf cohort study mein ── -->
          <div class="mt-3" *ngIf="activeTab === 'global' && isCohortStudy()">
            <div class="fw-bold font-16 mb-2 d-flex align-items-center">
              Site Sharing Among Cohorts
              <img placement="top" tooltipClass="tooltip-class" ngbTooltip=" Site Sharing identifies
                overlapping sites across related cohorts during the pre-feasibility stage, before site selection. Select
                a related cohort to identify shared sites, helping prevent double-counting and enabling more effective
                site planning, site activation, and risk management." class="cursor-pointer ms-1"
                src="assets/images/shared/info-icon.svg" height="12" width="12" alt="info">
            </div>

            <!-- All Sites Shared Toggle -->
            <div class="d-flex align-items-center mb-3">
              <div class="toggle-switch me-2">
                <label class="toggle mb-0">
                  <input type="checkbox" [(ngModel)]="allSitesShared">
                  <span class="slider round"></span>
                </label>
              </div>
              <span>
                All Sites Shared Among All Cohorts
                <img placement="top" tooltipClass="tooltip-class"
                  ngbTooltip="When enabled, all sites will be shared across all cohorts" class="cursor-pointer ms-1"
                  src="assets/images/shared/info-icon.svg" height="12" width="12" alt="info">
              </span>
            </div>

            <!-- Cohort Sharing Table -->
            <!-- Cohort Sharing Table -->
            <div style="border: 1px solid #cfdde6; border-radius: 4px; overflow: visible;">
              <!-- Header Row -->
              <div class="d-flex align-items-center px-3 py-2" style="background-color: #e5eaef;">
                <div style="width: 33%; font-size: 13px; color: #454250;" class="fw-bold">
                  Cohort <sup style="color: red;">*</sup>
                </div>
                <div style="width: 33%; font-size: 13px; color: #454250;" class="fw-bold">
                  # of Sites Shared <sup style="color: red;">*</sup>
                </div>
                <div style="width: 28%; font-size: 13px; color: #454250;" class="fw-bold">
                  Combination of Cohorts <sup style="color: red;">*</sup>
                </div>
                <div style="width: 6%;"></div>
              </div>

              <!-- Data Rows -->
              <div *ngFor="let row of cohortSharingRows; let i = index" class="d-flex align-items-start px-3 py-2"
                style="border-top: 1px solid #cfdde6;">

                <!-- Cohort — app-radius-dropdown -->
                <div style="width: 33%; padding-right: 8px;">
                  <app-radius-dropdown [items]="availableCohorts"
                    [selectedItem]="row.parent_dependency || 'Select Cohort'" [isDisabled]="allSitesShared || popupOpen"
                    [dropdownConfig]="dropdownConfigurations" (itemselected)="row.parent_dependency = $event">
                  </app-radius-dropdown>
                </div>


                <!-- # of Sites Shared -->
                <div style="width: 33%; padding-right: 8px;">
                  <input type="text" class="form-control form-control-sm w-100" [(ngModel)]="row.sites_shared"
                    placeholder="Enter number" onkeydown="if(event.key==='.'){event.preventDefault();}"
                    oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                    [disabled]="allSitesShared || popupOpen">
                </div>

                <!-- Combination of Cohorts — app-radius-dropdown + tags -->
                <div style="width: 28%; padding-right: 8px;">
                  <app-radius-dropdown [items]="availableCohorts" [selectedItem]="row.combination_of_cohort || []"
                    [isDisabled]="allSitesShared || popupOpen" [dropdownConfig]="dropdownConfigurationsMulti"
                    (itemselected)="row.combination_of_cohort = $event">
                  </app-radius-dropdown>
                  <!-- Selected tags -->

                </div>

                <!-- Delete -->
                <div style="width: 6%;" class="text-center pt-1">
                  <button class="btn btn-secondary-white p-0" (click)="removeCohortSharingRow(i)"
                    [disabled]="cohortSharingRows.length <= 1 || allSitesShared || popupOpen">
                    <img src="assets/images/shared/delete.svg" alt="delete" width="20" height="20">
                  </button>
                </div>

              </div>
            </div>

            <!-- Add Row Button -->
            <div class="mt-2">
              <button class="btn d-flex align-items-center px-3 py-1"
                style="border: 1px solid #27a6a4; color: #27a6a4; background: white; font-size: 13px; border-radius: 4px;"
                (click)="addCohortSharingRow()" [disabled]="allSitesShared || popupOpen">
                <span class="me-1" style="font-size: 18px; line-height: 1;">+</span> Add Row
              </button>
            </div>

            <!-- Error -->
            <div class="d-flex justify-content-between mb-1 w-100 mt-2" *ngIf="siteSharingSaveError.length > 0">
              <app-alerts [messageType]="'error'" [message]="siteSharingSaveError"
                (alertClosed)="siteSharingSaveError=''" [style.width.%]="100" [showCloseButton]="true"></app-alerts>
            </div>
          </div>
          <!-- ── END SITE SHARING ── -->

        </div>
        <!-- ── END Geography Activation block ── -->

        <!-- Range set block -->
        <div class="flex-fill card-block right-container mt-3" id="right-container">
          <div class="d-flex mb-2">
            <span class="font-16 fw-bold" *ngIf="activeTab === 'global'">Global Activation Co-ordinates</span>
            <span class="font-16 fw-bold txt-ellps" *ngIf="activeTab === 'country'">Country Activation
              Co-ordinates ({{selectedGeographyData.geographyName}})</span>
          </div>
          <div class="d-flex justify-content-between mb-1 w-100" *ngIf="errorMessage.length > 0">
            <app-alerts [messageType]="'error'" [message]="errorMessage" (alertClosed)="errorMessage=''"
              [style.width.%]="100" [showCloseButton]="true"></app-alerts>
          </div>
          <div class="d-flex justify-content-between mb-1 w-100" *ngIf="errorMessageDate.length > 0">
            <app-alerts [messageType]="'error'" [message]="errorMessageDate" (alertClosed)="errorMessageDate=''"
              [style.width.%]="100" [showCloseButton]="true"></app-alerts>
          </div>
          <div class="d-flex justify-content-between">
            <div class="item-inside d-flex align-items-center" *ngIf="activeTab === 'global'">
              <label class="custom-radio-button mb-0 d-flex align-items-center me-4 normal-font-weight">
                <input name="global-activation" type="radio" [value]="true"
                  (change)="siteActivationMethodChanged('global', true, false)"
                  [(ngModel)]="currentActivationData.siteActivationMethod"
                  [disabled]="studyDetails.historical_data_available == 'N' || currentActivationData.siteStartDate.input == '' || currentActivationData.siteEndDate.input == '' || popupOpen">
                <span></span>Historical
              </label>
              <label class="custom-radio-button mb-0 d-flex align-items-center me-4 normal-font-weight">
                <input name="global-activation" type="radio" [value]="false"
                  (change)="siteActivationMethodChanged('global', false, false)"
                  [(ngModel)]="currentActivationData.siteActivationMethod"
                  [disabled]="currentActivationData.siteStartDate.input == '' || currentActivationData.siteEndDate.input == '' || popupOpen">
                <span></span>Customized
              </label>
            </div>
            <div class="item-inside d-flex align-items-center" *ngIf="activeTab === 'country'">
              <label class="custom-radio-button mb-0 d-flex align-items-center me-4 normal-font-weight">
                <input type="radio" [value]="true"
                  [disabled]="(studyDetails.historical_data_available == 'N' && globalData.siteActivationMethod) || currentActivationData.siteStartDate.input == '' || currentActivationData.siteEndDate.input == '' || popupOpen"
                  [(ngModel)]="currentActivationData.siteActivationMethod"
                  (change)="siteActivationMethodChanged('country', true, false)"><span></span>
                <a *ngIf="!globalData.siteActivationMethod; else global_historical">Global Custom</a>
                <ng-template #global_historical>Global Historical</ng-template>
              </label>
              <label class="custom-radio-button mb-0 d-flex align-items-center me-4 normal-font-weight">
                <input name="selectActivationCurveCountry" type="radio" [value]="false"
                  [(ngModel)]="currentActivationData.siteActivationMethod"
                  [disabled]="currentActivationData.siteStartDate.input == '' || currentActivationData.siteEndDate.input == '' || popupOpen"
                  (change)="siteActivationMethodChanged('country', false, false)"><span></span>Customized
              </label>
            </div>
            <div class="item toggle-switch d-flex">
              <label class="item-label d-flex align-items-center fw-bold mb-2 me-2">
                <span>Date
                  <img placement="bottom" tooltipClass="tooltip-class"
                    ngbTooltip="Show activation progress by actual calendar dates instead of % duration in days."
                    class="cursor-pointer ms-1 mb-1" src="assets/images/shared/info-icon.svg" height="12" width="12"
                    alt="tooltip">
                </span>
              </label>
              <div>
                <label class="toggle">
                  <input type="checkbox" [checked]="getToggleValue()" [(ngModel)]="date_toggle"
                    (click)="legendToggle(activeTab, 0, $event, false,'date')"
                    [disabled]="currentActivationData.siteActivationMethod || this.currentActivationData.siteStartDate.input == '' || this.currentActivationData.siteEndDate.input == '' || !accessMode || popupOpen">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>

          <div class="table country-level" id="coordinate"
            [ngClass]="{'cust-grid': !currentActivationData.siteActivationMethod }">
            <div class="table-header d-flex">
              <th class="column fw-bold d-flex mb-1 justify-content-end" *ngIf="!currentActivationData.toggleSelection">
                % Site Activation Duration<sup class="pt-3" style="background: none !important;">*</sup>
              </th>
              <th class="column fw-bold d-flex mb-1 justify-content-end" *ngIf="currentActivationData.toggleSelection">
                Date of Activation<sup class="pt-3" style="background: none !important;">*</sup>
              </th>
              <th class="column fw-bold d-flex mb-1 justify-content-end">% Sites Activated<sup class="pt-3"
                  style="background: none !important;">*</sup></th>
              <th class="column fw-bold d-flex mb-1 justify-content-end"
                *ngIf="!currentActivationData.siteActivationMethod"># of Sites Activated<sup class="pt-3"
                  style="background: none !important;">*</sup></th>
              <th class="column fw-bold d-flex mb-1 justify-content-end"
                *ngIf="!currentActivationData.siteActivationMethod">Delete</th>
              <th *ngIf="currentActivationData.siteActivationMethod"
                style="visibility:hidden; width: 0; padding: 0; min-width: 0;"></th>
            </div>
            <tbody class="table-body" id="input-grid">
              <ng-container *ngFor="let row of inputGridData; let i=index; let f=first; let l=last">
                <tr *ngIf="f || l" class="fixrow">
                  <td>
                    <span
                      *ngIf="!currentActivationData.toggleSelection && !(currentActivationData.siteActivationMethod && activeTab == 'country' && !globalData.siteActivationMethod && globalData.toggleSelection); else gridElseBlock">{{row.perc_trial_duration}}</span>
                    <ng-template #gridElseBlock>{{row.perc_trial_duration.input}}</ng-template>
                  </td>
                  <td>{{row.perc_site_activated}}</td>
                  <td *ngIf="!currentActivationData.siteActivationMethod">{{ i != 0 ? inputGridData.target_no_sites : 0
                    }}</td>
                  <td *ngIf="!currentActivationData.siteActivationMethod"></td>
                </tr>
                <tr *ngIf="!f && !l">
                  <td>
                    <span *ngIf="!getToggleValue()">
                      <input type="text" class="" [(ngModel)]="row.perc_trial_duration"
                        [ngClass]="{'error-required': isError && focussedItem.row === i && focussedItem.column === 'perc_trial_duration'}"
                        onkeydown="if(event.key==='.'){event.preventDefault();}"
                        oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                        [ngModel]="row.perc_trial_duration?.input ?? row.perc_trial_duration"
                        (ngModelChange)="setGridData($event, i, 'perc_trial_duration')"
                        (focus)="onGridInputFocus(i, 'perc_trial_duration')"
                        (focusout)="onGridInputFocusOut(i, 'perc_trial_duration')"
                        [disabled]="isGridInputDisabled(i, 'perc_trial_duration') || popupOpen">
                    </span>
                    <span *ngIf="getToggleValue()">
                      <input class="calendar" autoClose=true ngbDatepicker placement="bottom-left" [startDate]=""
                        (dateSelect)="setGridData(date, i, 'perc_trial_duration')" #date="ngbDatepicker"
                        [(ngModel)]="row.perc_trial_duration.model" (keydown)="$event.preventDefault();"
                        [minDate]="inputGridData[i -1].perc_trial_duration.model"
                        [startDate]="inputGridData[i -1].perc_trial_duration.model"
                        (click)="date.toggle(); $event.stopPropagation();" autocomplete="off"
                        [disabled]="isGridInputDisabled(i, 'perc_trial_duration') || popupOpen">
                    </span>
                  </td>
                  <td>
                    <input type="text" class="" [(ngModel)]="row.perc_site_activated"
                      [ngClass]="{'error-required': isError && focussedItem.row === i && focussedItem.column === 'perc_site_activated'}"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                      (ngModelChange)="setGridData($event, i, 'perc_site_activated')"
                      (focus)="onGridInputFocus(i, 'perc_site_activated')"
                      (focusout)="onGridInputFocusOut(i, 'perc_site_activated')"
                      [disabled]="isGridInputDisabled(i, 'perc_site_activated') || popupOpen">
                  </td>
                  <td *ngIf="!currentActivationData.siteActivationMethod">
                    <input type="text" class="" [(ngModel)]="row.target_no_sites"
                      [ngClass]="{'error-required': isError && focussedItem.row === i && focussedItem.column === 'target_no_sites'}"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                      (ngModelChange)="setGridData($event, i, 'target_no_sites')"
                      (focus)="onGridInputFocus(i, 'target_no_sites')"
                      (focusout)="onGridInputFocusOut(i, 'target_no_sites')"
                      [disabled]="isGridInputDisabled(i, 'target_no_sites') || popupOpen">
                  </td>
                  <td *ngIf="!currentActivationData.siteActivationMethod">
                    <button class="btn btn-secondary-white p-0" (click)="deleteCoordinate(i)"
                      [disabled]="inputGridData.length <= requiredCoordinates || !accessMode || popupOpen">
                      <img src="assets/images/shared/delete.svg" alt="delete">
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </div>

          <div class="d-flex justify-content-end cursor-pointer mt-2"
            [ngClass]="{'disabled': !accessMode || popupOpen }" *ngIf="!currentActivationData.siteActivationMethod">
            <img src="assets/images/shared/add.svg" alt="" class="pe-2">
            <span style="color: #27a6a4;" (click)="addCoordinate(currentActivationData.toggleSelection)">Add
              Coordinate</span>
          </div>
          <div class="clearfix"></div>
          <div class="d-flex mb-2" *ngIf="!currentActivationData.siteActivationMethod">
            <button class="button-secondary"
              (click)="createChart(activeTab, inputGridData, this.activeIndex, getToggleValue(), true)"
              [disabled]="enableCalculateButton()">Calculate Activation Curve</button>
          </div>
        </div>

      </div>

      <div></div>

      <!-- col-2 -->
      <div class="d-flex col-6 flex-column">
        <div class="card-block h-15 flex-fill">
          <div *ngIf="!tabDataLoading">
            <div class="d-flex mb-4">
              <span class="font-16 fw-bold" *ngIf="activeTab === 'global'">Global Activation Duration</span>
              <span class="font-16 fw-bold txt-ellps" *ngIf="activeTab === 'country'">Country Activation
                Duration ({{selectedGeographyData.geographyName}})</span>
            </div>
            <div class="d-flex mb-4 mx-0">
              <div class="item start-date me-4">
                <label class="item-label d-flex align-items-center fw-bold mb-2">
                  <span>
                    Site Activation Start <sup>*</sup>
                    <img placement="bottom" tooltipClass="tooltip-class"
                      ngbTooltip="Date by which the sites start getting activated" class="cursor-pointer ms-1 mb-1"
                      src="assets/images/shared/info-icon.svg" height="12" width="12" alt="tooltip">
                  </span>
                </label>
                <div class="item-input">
                  <input class="calendar" autoClose=true ngbDatepicker placement="bottom-left"
                    [startDate]="currentActivationData.siteStartDate.model"
                    (dateSelect)="validateSiteDates(activeTab, siteStartDate, 'siteStartDate', activeIndex)"
                    #siteStartDate="ngbDatepicker" [(ngModel)]="currentActivationData.siteStartDate.model"
                    (keydown)="$event.preventDefault();" (click)="siteStartDate.toggle(); $event.stopPropagation();"
                    autocomplete="off" [disabled]="currentActivationData.siteActivationMethod || popupOpen">
                </div>
              </div>
              <div class="item end-date">
                <label class="item-label d-flex align-items-center fw-bold mb-2">
                  <span>
                    Site Activation End<sup>*</sup>
                    <img placement="top" tooltipClass="tooltip-class"
                      ngbTooltip="Date by which all the sites are activated" class="cursor-pointer ms-1 mb-1"
                      src="assets/images/shared/info-icon.svg" height="12" width="12" alt="tooltip" placement="bottom">
                  </span>
                </label>
                <div class="item-input">
                  <input class="calendar" autoClose=true ngbDatepicker placement="bottom-left"
                    [startDate]="currentActivationData.siteEndDate.model || currentActivationData.siteStartDate.model"
                    (dateSelect)="validateSiteDates(activeTab, siteEndDate, 'siteEndDate', activeIndex)"
                    #siteEndDate="ngbDatepicker" [(ngModel)]="currentActivationData.siteEndDate.model"
                    (keydown)="$event.preventDefault();" (click)="siteEndDate.toggle(); $event.stopPropagation();"
                    autocomplete="off" [disabled]="currentActivationData.siteActivationMethod || popupOpen">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Graph container -->
        <div class="card-block h-80 flex-fill flex-column">
          <div class="d-flex mb-4" style="justify-content: space-between;">
            <div class="d-flex">
              <span class="font-16 fw-bold" *ngIf="activeTab === 'global'">Global Activation Curve</span>
              <span class="font-16 fw-bold txt-ellps" *ngIf="activeTab === 'country'">Country Activation
                Curve ({{selectedGeographyData.geographyName}})</span>
            </div>
            <div class="item toggle-switch d-flex">
              <label class="item-label d-flex align-items-center fw-bold mb-2 me-2">
                <span># Sites Activated</span>
              </label>
              <div>
                <label class="toggle">
                  <input type="checkbox" [checked]="false"
                    (click)="legendToggle(activeTab, 0, $event, true,'no_of_sites')"
                    [(ngModel)]="target_no_sites_toggle">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="h-100" id="chart-container" [ngStyle]="{width: '100%', display: 'block'}"></div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="modal-footer d-flex py-0 d-flex justify-content-start">
  <button type="button" class="button-primary me-3" (click)="modalDismissed('Update')" [disabled]="disableSave()">
    Save & Apply
  </button>
  <div class="cursor-pointer" (click)="modalDismissed('Cancel')" [ngClass]="{'disabled': popupOpen}">
    <img src="assets/images/shared/cancel.svg" class="me-1" width="16" height="16">
    Cancel
  </div>
</div>

<ng-template let-modal #alertModal>
  <div>
    <div class="modal-header">
      <h5 class="modal-title">{{ alertConfig.title }}</h5>
    </div>
    <div class="modal-body" style="min-height: 10vh!important; max-height: 12vh!important;">
      <span>{{alertConfig.content}}</span>
    </div>
    <div class="modal-footer custom-footer">
      <button class="button-primary me-2" ctfoDialogClose (click)="alertConfig.afterOK()">OK</button>
      <div class="cancel-button d-flex ng-star-inserted btn-secondary-white" ctfoDialogClose
        (click)="alertConfig.afterCancel()">
        <img src="assets/images/shared/cancel.svg" alt="cancel" class="cursor-pointer" width="15px">
        <span>Cancel</span>
      </div>
    </div>
  </div>
</ng-template>